import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAMadaJq6T4PDxW9Dc338v6f3hYSrIIA90",
  authDomain: "stok-takip-e5d29.firebaseapp.com",
  projectId: "stok-takip-e5d29",
  storageBucket: "stok-takip-e5d29.appspot.com",
  messagingSenderId: "383922504913",
  appId: "1:383922504913:web:2d9ee7031ad533ba21b1f0",
  measurementId: "G-2SM32EYM4Q"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);